
<script setup>

  import { ArrowRightCircleIcon } from '@heroicons/vue/24/outline';

  import { questions } from '../stores/activity-2.js';

  import TextArea from '../components/text-area.vue';

  import SaveNotice from '../partials/save-notice.vue';

  import CarIcon from '../icons/car-icon.vue';

  import RoadIcon from '../icons/road-icon.vue';

  import GasIcon from '../icons/gas-icon.vue';

  import UtensilsIcon from '../icons/utensils-icon.vue';

  import HatIcon from '../icons/hat-icon.vue';

  import backgroundPath from '../images/map-background.jpg';

</script>

<template>

  <article>

    <div class="min-h-view bg-fixed bg-cover bg-center" :style="{ backgroundImage: `url( ${ backgroundPath } )` }">

      <img class="w-full -mb-2 md:-mb-6 lg:-mb-12" src="../images/activity-2-part-7-hero.png" alt="Black visitors standing on the porch of a rental cabin at Lewis Mountain." />

      <div class="p-6 md:p-12 lg:p-24 mx-auto max-w-2xl">

        <h3 class="text-3xl md:text-5xl font-heading uppercase">You finally arrive at Lewis Mountain Campground</h3>

        <p class="mt-8 text-neutral-700">

          You rent a cabin for your family, and after you unpack, you begin to reflect on your journey.

        </p>

        <div class="flex items-center gap-4 mt-12">

          <div class="flex items-center justify-center min-w-[64px]">

            <CarIcon class="w-12 text-green-700" />

          </div>

          <p class="font-bold">Think about all the extra supplies you had to prepare and pack for your family.</p>

        </div>

        <div class="flex items-center gap-4 mt-12">

          <div class="flex items-center justify-center min-w-[64px]">

            <RoadIcon class="w-12 text-green-700" />

          </div>

          <p class="font-bold">Think about why you chose the route you did.</p>

        </div>

        <div class="flex items-center gap-4 mt-12">

          <div class="flex items-center justify-center min-w-[64px]">

            <GasIcon class="w-10 text-green-700" />

          </div>

          <p class="font-bold">Remember your experience finding a gas station.</p>

        </div>

        <div class="flex items-center gap-4 mt-12">

          <div class="flex items-center justify-center min-w-[64px]">

            <UtensilsIcon class="w-8 text-green-700" />

          </div>

          <p class="font-bold">Reflect on your experience when stopping to eat.</p>

        </div>

        <div class="flex items-center gap-4 mt-12">

          <div class="flex items-center justify-center min-w-[64px]">

            <HatIcon class="w-13 text-green-700" />

          </div>

          <p class="font-bold">Think about the woman and the ranger at the picnic grounds.</p>

        </div>

        <div v-for="{ id, question, answer } in questions" class="mt-24">
          
          <label class="font-bold" :for="id">{{ question }}</label>
        
          <TextArea :id="id" v-model="answer.value" v-slot="{ count, maxLength }">
            
            <div class="text-right mt-2 text-sm italic">{{ count }} of {{ maxLength }} characters used.</div>
          
          </TextArea>

        </div>

        <SaveNotice class="mt-12" />

        <div class="flex justify-end mt-12">

          <RouterLink

            class="inline-flex items-center gap-4 px-6 py-4 text-white font-bold text-white bg-green-700 transition-colors
            
              hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline"
          
            to="/activity/2/review">
            
            <span>Review</span>

            <ArrowRightCircleIcon class="w-8" />
          
          </RouterLink>

        </div>

      </div>

    </div>

  </article>

</template>
